module.exports = __webpack_public_path__ + "img/contact_map.9b2bd680.png";